module.exports = __webpack_public_path__ + "media/images/front/products/icon_ultrasound-71b5a63ae8656e02bfe47fa4e1f16584.svg";